import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logger from '../../utils/logger';
import { authStorage } from '../../utils/storage';
import { jwtDecode } from 'jwt-decode';
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    useNavigate();
    
    // Initialize auth state from storage
    const initAuthState = () => {
        logger.log('AuthContext', 'Initializing auth state');
        const token = authStorage.getToken();
        if (token) {
            try {
                const decodedUser = jwtDecode(token);
                
                // Check if token is expired
                const currentTime = Date.now() / 1000;
                if (decodedUser.exp && decodedUser.exp < currentTime) {
                    logger.log('AuthContext', 'Token expired, clearing session');
                    authStorage.clearAuthData();
                    return { token: null, isAuthenticated: false, user: null };
                }
                
                logger.log('AuthContext', 'Token found and valid', { username: decodedUser.username, role: decodedUser.role });
                return { token, isAuthenticated: true, user: decodedUser };
            } catch (error) {
                logger.error('AuthContext', 'Invalid token', error);
                authStorage.clearAuthData();
                return { token: null, isAuthenticated: false, user: null };
            }
        }
        logger.log('AuthContext', 'No token found');
        return { token: null, isAuthenticated: false, user: null };
    };
    
    const [auth, setAuth] = useState(initAuthState);
    const [isInitialized] = useState(true);

    // Listen for storage events to sync auth across tabs
    useEffect(() => {
        const handleStorageChange = () => {
            const newAuthState = initAuthState();
            setAuth(newAuthState);
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return (
        <AuthContext.Provider value={{ auth, setAuth, isInitialized }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);